<template>
  <div class="row align-items-center">
    <div class="" v-for="(post, index) in posts" :key="index">
      <hr />
      <div class="card-row banner-mobile" v-if="post.promotion">
        <div class="col-12">
          <a :href="`${post.cover.url}`">
            <img
              :src="`${post.cover.image}`"
              alt="Banner"
              width="300"
              height="250"
            />
          </a>
        </div>
      </div>
      <div class="card-row" v-else>
        <div class="col-5">
          <NuxtLink
            v-if="post.content_type"
            :to="{
              name: 'language-blog-id-slug',
              params: {
                language: route.params.language,
                id: post.id,
                slug: post.slug,
              },
            }"
          >
            <ContagemRegressivaLive :inicio="post.liveCountdown" :capa="post.cover" largura="135" altura="76">
              <img
                width="135"
                height="76"
                :src="`${post.cover}`"
                :alt="post.title"
              />
            </ContagemRegressivaLive>
          </NuxtLink>
          <a v-else :href="post.link_redirect">
            <ContagemRegressivaLive :inicio="post.liveCountdown" :capa="post.cover" largura="135" altura="76">
              <img
                width="135"
                height="76"
                :src="`${post.cover}`"
                :alt="post.title"
              />
            </ContagemRegressivaLive>
          </a>
        </div>
        <div class="col-7">
          <NuxtLink
            v-if="post.content_type"
            :to="{
              name: 'language-blog-id-slug',
              params: {
                language: route.params.language,
                id: post.id,
                slug: post.slug,
              },
            }"
            class="button--more"
          >
            <div class="card-title">{{ post.title }}</div>
            <p
              class="card-text mt-2"
              v-for="description in post.meta_description"
              :key="description.language_id"
            >
              <span
                v-if="
                  description.language_id === 1 &&
                  route.params.language === 'pt-br'
                "
                v-text="description.content"
              ></span>
              <span
                v-if="
                  description.language_id === 2 &&
                  route.params.language === 'en'
                "
                v-text="description.content"
              ></span>
            </p>
          </NuxtLink>
          <a v-else :href="post.link_redirect">
            <div class="card-title">{{ post.title }}</div>
            <p
              class="card-text mt-2"
              v-for="description in post.meta_description"
              :key="description.language_id"
            >
              <span
                v-if="
                  description.language_id === 1 &&
                  route.params.language === 'pt-br'
                "
                v-text="description.content"
              ></span>
              <span
                v-if="
                  description.language_id === 2 &&
                  route.params.language === 'en'
                "
                v-text="description.content"
              ></span>
            </p>
          </a>
        </div>
      </div>
    </div>

    <NuxtLink
      v-if="home"
      :to="{
        name: 'language-blog',
        params: {
          language: route.params.language,
        },
      }"
      class="button button--o"
    >
      {{ translate.goToBlog }}
      <font-awesome
        :icon="['fas', 'arrow-right']"
        size="lg"
        style="margin-left: 10px"
      />
    </NuxtLink>
  </div>
</template>

<script lang="ts" setup>
import translateMain from "@/tradutors/menu";
import ContagemRegressivaLive from "@/components/Blog/ContagemRegressivaLive.vue";

const props = defineProps(["posts", "home"]);
const route = useRoute();
const translate = computed(() =>
  route.params.language == "pt-br"
    ? translateMain.portugues
    : translateMain.ingles
);
</script>
<style scoped>
.card-title {
  color: #b20000;
  font-family: "Roboto-Medium";
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 21px;
  padding: 0 10px;
}

.card-text {
  color: #5b5858;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
  padding: 0 10px;
}

.card-text span {
  font-family: "Roboto-Regular";
}

.button--more svg {
  color: #b20000;
}

.button--more {
  font-family: "Exo-2";
  font-weight: bold;
}

.small svg {
  margin-right: 5px;
}

.card-row img {
  width: 100%;
  object-fit: cover;
  height: auto;
}

/* Contagem regressiva da live no lugar da capa: mesma caixa da imagem. */
.card-row .contagem-live {
  width: 100%;
  height: auto;
}

.card-row {
  background-color: var(--bs-white);
  width: 100%;
  display: flex;
  min-height: 170px;
}

.banner-mobile {
  height: unset;
}

.banner-mobile img {
  width: 100%;
  object-fit: cover;
}

hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #aaaaaa;
  margin: 30px 0px;
  padding: 0px;
}

.button--o {
  color: #ffffff;
  font-family: "Exo-2";
  font-size: 16px;
  letter-spacing: 0;
  background-color: #000000;
  padding-left: 47px;
  padding-right: 49px;
  width: 220px;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: 60px;
}

.button--o svg {
  color: #b20000;
}
</style>
